import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UUIDService {
  /**
   * @returns a RFC 4122 UUID v4 from `crypto.randomUUID()`
   */
  public generate(): string {
    return crypto.randomUUID();
  }
}
